module.exports = "/_next/static/images/0f9712600805c20a70513f39fe02218a-roxinho-details-metalico-md@1x.jpg.webp";